import pluralizeLib from 'pluralize';

export default function pluralize(word, count) {
    return pluralizeLib(word, count);
}
